import React from 'react';
import { Alert, Flex } from '@fluentui/react-northstar';
import { ExclamationTriangleIcon } from '@fluentui/react-icons-northstar';
import PropTypes from "prop-types";

const AlertError = (props) => {
  const { title, text, testId, dismissAlert } = props;

  return (
    //add flex to fix issues with styling of the alert
    <Flex>
      <Alert
        warning
        data-testid={testId}
        icon={<ExclamationTriangleIcon />}
        header={title}
        content={text}
        dismissible
        dismissAction={{
          onClick: dismissAlert,
          'aria-label': 'close',
        }}
      />
    </Flex>
  );
};

AlertError.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  testId: PropTypes.string,
  dismissAlert: PropTypes.func,
};

AlertError.defaultProps = {
  title: "",
  text: "",
  testId: "alertError",
};

export default AlertError;
